// ── Citation source type literals ─────────────────────────────────────────────
export const CITATION_SOURCE_TYPE = {
    DOCUMENT: 'document',
    TOOL: 'tool',
    MODEL_KNOWLEDGE: 'model_knowledge',
} as const;

// ── Citation rendering constants ──────────────────────────────────────────────
// File-icon constants moved to ../FileAttachmentCard/FileAttachmentCard.constants.ts
// (RECUR-26809 extracted the shared card); this file holds citation constants only.

/** Regex to detect inline citation sentinels (e.g. ‹cite:3› or multi-id ‹cite:3,4›).
 *  The capture group holds one or more comma-separated ids — the plugin emits a
 *  marker per id, so a model that bundles ids never leaks the literal token. */
export const CITATION_SENTINEL_REGEX = /‹cite:(\d+(?:\s*,\s*\d+)*)›/g;

/** Regex to detect table-source annotations (e.g. ‹table-sources:1, 5›). Tolerates spaces. */
export const TABLE_SOURCES_SENTINEL_REGEX = /‹table-sources:([\d,\s]+)›/;

/** The CSS id prefix used for SourcesPanel anchor targets. */
export const SOURCE_ANCHOR_PREFIX = 'source-';

/** SourcesPanel group headings. Tool/data sources are shown to non-technical
 *  business users, so internal server names (Polus/Underwriting/…) are never
 *  surfaced — all tool-derived sources sit under one user-facing label. */
export const SOURCES_GROUP_DOCUMENTS = 'Documents';
export const SOURCES_GROUP_INGESTED = 'AICA Report (Ingested Data)';

/** Duration (ms) before the highlight class is removed after scroll. */
export const SOURCE_HIGHLIGHT_DURATION_MS = 1500;
